// =============================================
// COMPONENTE: ActionsBadge
// =============================================
// Arquivo: ActionsBadge.tsx
// Descrição: Badge reutilizável para mostrar quantidade de ações configuradas
// =============================================

import React from 'react';

interface ActionsBadgeProps {
  actions?: {
    input?: any[];
    output?: any[];
  };
}

const ActionsBadge: React.FC<ActionsBadgeProps> = ({ actions }) => {
  const actionsCount = (actions?.input?.length || 0) + (actions?.output?.length || 0);

  if (actionsCount === 0) return null;

  return (
    <div className="node-badge success" title={`${actionsCount} ação${actionsCount > 1 ? 'ões' : ''} configurada${actionsCount > 1 ? 's' : ''}`}>
      ⚡ {actionsCount} ação{actionsCount > 1 ? 'ões' : ''}
    </div>
  );
};

export default ActionsBadge;
